import styled, { css } from "styled-components";
import * as palette from "../../SCVariables";
import { Link as LinkScroll } from "react-scroll";

export const HIWContainer = styled.div`
  height: 500px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 50px;
  justify-content: center;
  background: ${palette.mainWhite};
  align-items: center;
  text-align: center;
  padding: 40px;

  @media screen and (max-width: 800px) {
    height: 700px;
    grid-template-columns: 1fr;
    grid-row-gap: 50px;
  }
`;

export const Header = styled.h1``;

export const HIWWrapper = styled.div`
  justify-content: center;
  padding: 50px;
  text-align: center;
`;
const Shared = css`
  border: 1px solid #4444;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 5px 5px #4444;
  height: 200px;
`;
export const Column1 = styled.div`
  ${Shared}
`;
export const Column2 = styled.div`
  ${Shared}
`;
export const Column3 = styled.div`
  ${Shared}
`;
export const ColunmHeader = styled.h1`
 margin-bottom: 12px;

  @media screen and (max-width: 1024px) {
   font-size: 20px;
`;
export const ColunmSubHeader = styled.h2`
  margin-bottom: 10px;
  @media screen and (max-width: 1024px) {
   font-size: 15px;
`;
export const ColunmParagraph = styled.p`
  text-align: center;

  @media screen and (max-width: 1024px) {
   text-align:center;
   font-size: 12px;

  @media screen and (max-width: 800px) {
   text-align:center;

`;
